import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { useStyles } from './styles';
import { CustomTabProps } from '../../interfaces/index.types';
import { colors } from '../../interfaces/color.types';

function CustomTab(props: CustomTabProps) {
  const enabled = props.id === props.value;
  const classes = useStyles();

  const randomColor = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * colors.length);
    return { bgColor: colors[randomIndex]?.bgrColor || 'none', color: colors[randomIndex]?.color || 'none' };
  }, [colors, props.id]);

  return (
    <Box sx={{ bgcolor: enabled ? 'rgba(242, 251, 243, 1)' : 'none' }} className={classes.Box}>
      <Typography
        sx={{
          color: enabled ? 'var(--Primary-700, #296C32)' : 'var(--Gray-500, #667085)',
        }}
        fontSize={16}
        fontWeight={600}
        lineHeight={'24px'}
      >
        {props.label}
      </Typography>
      {props.id !== 0 && (
        <Box
          className={classes.BoxCustomTab}
          sx={{
            background: randomColor.bgColor,
          }}
        >
          <Typography
            fontWeight={500}
            textAlign={'center'}
            fontSize={14}
            lineHeight={'20px'}
            sx={{
              color: randomColor.color,
            }}
          >
            {props.total}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default CustomTab;
